import React, { useState } from 'react'
import { Button, Card, Form, Input } from 'antd'
import { actions } from '../../../../store/reducers/admin.reducer'
import { connect } from 'react-redux'
import { passwordIconRender, validateStrongPassword, PasswordRequirements, validatePasswordMatch } from '../../../../utils/antd.helper'

const ChangePasswordCard = ({ changePassword }) => {
    const [form] = Form.useForm()
    const password = Form.useWatch('password', form)
    const [isWaitingForChangePassword, setIsWaitingForChangePassword] = useState(false)

    const handleChangePassword = async values => {
        try {
            setIsWaitingForChangePassword(true)
            await changePassword(values.oldPassword, values.password)
            setIsWaitingForChangePassword(false)
            form.resetFields()
        } catch (error) {
            setIsWaitingForChangePassword(false)
        }
    }

    return (
        <Card title='Change Password' bordered={false} className='mb-32'>
            <Form
                form={form}
                name='changePassword'
                onFinish={handleChangePassword}
                layout='vertical'
                requiredMark={false}
                validateTrigger={['onBlur', 'onSubmit']}
            >
                <Form.Item
                    label='Old Password'
                    name='oldPassword'
                    rules={[{ required: true, message: 'Please, input your old password' }]}
                >
                    <Input.Password iconRender={passwordIconRender} />
                </Form.Item>
                <Form.Item
                    label='New Password'
                    name='password'
                    rules={[
                        { required: true, message: 'Please, input your new password' },
                        { validator: validateStrongPassword }
                    ]}
                    extra={<PasswordRequirements value={password} />}
                >
                    <Input.Password iconRender={passwordIconRender} />
                </Form.Item>
                <Form.Item
                    label='Confirm New Password'
                    name='confirmNewPassword'
                    dependencies={['password']}
                    hasFeedback
                    rules={[
                        { required: true, message: 'Please, confirm your new password' },
                        validatePasswordMatch
                    ]}
                >
                    <Input.Password iconRender={passwordIconRender} />
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' block loading={isWaitingForChangePassword}>
                        Change
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

const mapDispatch = dispatch => {
    return {
        changePassword(oldPassword, newPassword) {
            return dispatch(actions.changePassword(oldPassword, newPassword))
        },
    }
}

export default connect(null, mapDispatch)(ChangePasswordCard)
